import { render, staticRenderFns } from "./kefuPop.vue?vue&type=template&id=9745e234&scoped=true"
import script from "./kefuPop.vue?vue&type=script&lang=js"
export * from "./kefuPop.vue?vue&type=script&lang=js"
import style0 from "./kefuPop.vue?vue&type=style&index=0&id=9745e234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9745e234",
  null
  
)

export default component.exports